import React from "react";
import Empty from "../../assets/assets/empty.svg";
import TestCard from "../../pages/Dashboard/TestCard";
import { PropTypes } from "prop-types";

const Pending = (props) => {
  const {
    status,
    application,
    companyId,
    results,
    resultsLength,
    getStatus,
    categoryChoice,
    testCardStatus,
    userType,
    pos,
    expired
  } = props;

  const statusUpdate = status && status[0] && status[0].update;
  const updatingStatus =
    status && status[0] && status[0].nibss_super_admin_status;
  const updatingStatus2 = status && status[0] && status[0].status;
  const posId = pos && pos[0] && pos[0].id;
  const certifiedStatus =
    updatingStatus === "pending" || updatingStatus2 === "pending";

  return (
    !statusUpdate &&
    application.nibss_super_admin_status === "pending" &&
    (application.status === "pending" || application.status === "approved") && (
      <div className="pos-doc-sec">
        <div className="empty2">
          <div>
            <img src={Empty} alt="empty2" />
          </div>
          <h1>No Products</h1>
          <p>
            There are no products recieved. Please check back when your <br />{" "}
            application has been accepted.
          </p>
          <br />
        </div>
        <div className="testcard-main" style={{ marginTop: "0px" }}>
          <TestCard
            certifiedStatus={certifiedStatus}
            appId={posId}
            companyId={companyId}
            userType={userType}
            results={results}
            resultsLength={resultsLength}
            getUserStatus={getStatus}
            categoryChoice={categoryChoice}
            testCardStatus={testCardStatus}
                expired={expired}
          />
        </div>
      </div>
    )
  );
};

Pending.propTypes = {
  status: PropTypes.array,
  application: PropTypes.object,
  companyId: PropTypes.number,
  results: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  resultsLength: PropTypes.array,
  getStatus: PropTypes.func,
  categoryChoice: PropTypes.number,
  testCardStatus: PropTypes.number,
  userType: PropTypes.string,
  pos: PropTypes.array,
}

export default Pending;
